import { getStoreId } from "$/hooks/use-store-information"
import feeQueries from "$/lib/queries/fee-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/fee")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) queryClient.prefetchQuery(feeQueries.list({ storeId }))
    return {
      crumbs: "alfred.settings.nav.fee.label",
    }
  },
})
